import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Base from "./Base";
import { computed, makeObservable, observable, reaction, runInAction } from "mobx";
import DeliveryModel from "./models/DeliveryModel";
import TimesModel from "./models/TimeModel";
import DPServices, { UserTypes } from "@dp/services";
import { formatDate, ORDER_TYPES, PlatformType } from "@dp/common";
import moment from "moment";
import { fetchDistances } from "../utils";
import orderBy from "lodash/orderBy";
var Delivery = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Delivery, _Base);

  var _super = _createSuper(Delivery);

  function Delivery(rootStore) {
    var _this;

    var isToGo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, Delivery);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "deliveryModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "timeModel", null);

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "_isDeliveryLoading", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isDeliveryPageLoading", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isDeliverySwitchLoading", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_showHeaderHamburgerMenu", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_storeName", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isTogo", _descriptor6, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "selectRestaurant", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(restaurantNum) {
        var _this$rootStore, _this$rootStore$user, _this$rootStore2, _this$rootStore2$comm, _this$rootStore3, _this$rootStore3$user, _this$rootStore3$user2, _this$rootStore3$user3, jwtToken;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.isDeliveryLoading = true;
                _context.next = 4;
                return (_this$rootStore = _this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$user = _this$rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : _this$rootStore$user.getTokenSilentIfLoggedIn();

              case 4:
                jwtToken = _context.sent;
                _context.next = 7;
                return DPServices.Restaurant.updateLocation({
                  validateCartItems: true,
                  asapSelected: false,
                  restaurantNum: restaurantNum,
                  orderId: (_this$rootStore2 = _this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$comm = _this$rootStore2.common) === null || _this$rootStore2$comm === void 0 ? void 0 : _this$rootStore2$comm.orderID,
                  orderType: ((_this$rootStore3 = _this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$user = _this$rootStore3.user) === null || _this$rootStore3$user === void 0 ? void 0 : (_this$rootStore3$user2 = _this$rootStore3$user.sessionDetails) === null || _this$rootStore3$user2 === void 0 ? void 0 : (_this$rootStore3$user3 = _this$rootStore3$user2.orderContext) === null || _this$rootStore3$user3 === void 0 ? void 0 : _this$rootStore3$user3.orderTypeValue) || 0
                }, jwtToken);

              case 7:
                _context.next = 9;
                return _this.rootStore.user.updateSession();

              case 9:
                _this.isDeliveryLoading = false;

                _this.rootStore.platformUtil.navigateToRoute("/menu");

                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                _this.isDeliveryLoading = false;

                _this.appMessages.showError("Something went wrong", "Delivery to pickup switch failed");

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 13]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _this.rootStore = rootStore;
    _this.appMessages = rootStore.appMessages;
    _this.deliveryModel = new DeliveryModel(_this.rootStore.platformUtil, isToGo);
    _this.timeModel = new TimesModel(_this.rootStore.platformUtil);
    _this._isTogo = isToGo;

    if (isToGo) {
      _this.deliveryModel.showPickupBtn = false;
    } else {
      _this.deliveryModel.showPickupBtn = true;
    }

    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Delivery, [{
    key: "_processSessionDetails",
    value: function _processSessionDetails(session) {
      var _this$deliveryModel, _this$timeModel, _session$deliveryGrou;

      this === null || this === void 0 ? void 0 : (_this$deliveryModel = this.deliveryModel) === null || _this$deliveryModel === void 0 ? void 0 : _this$deliveryModel.setSessionDetails(session);
      this.timeModel.resetTimeModel();
      this === null || this === void 0 ? void 0 : (_this$timeModel = this.timeModel) === null || _this$timeModel === void 0 ? void 0 : _this$timeModel.setSessionDetails(session);
      this.deliveryModel.noOfGuests = session === null || session === void 0 ? void 0 : (_session$deliveryGrou = session.deliveryGroup) === null || _session$deliveryGrou === void 0 ? void 0 : _session$deliveryGrou.partySize;
    }
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this; //session-details


      reaction(function () {
        var _this2$rootStore, _this2$rootStore$user;

        return {
          sessionDetails: _this2 === null || _this2 === void 0 ? void 0 : (_this2$rootStore = _this2.rootStore) === null || _this2$rootStore === void 0 ? void 0 : (_this2$rootStore$user = _this2$rootStore.user) === null || _this2$rootStore$user === void 0 ? void 0 : _this2$rootStore$user.sessionDetails
        };
      }, /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this2._processSessionDetails(data === null || data === void 0 ? void 0 : data.sessionDetails);

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "createQuote",
    value: function () {
      var _createQuote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(pickupTime) {
        var _this$deliveryModel2, _this$deliveryModel3, _this$deliveryModel4, _this$deliveryModel4$;

        var deliveryFrom, deliveryFromCountry, quoteRequest, _this$rootStore4, _this$rootStore4$user;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                deliveryFrom = (_this$deliveryModel2 = this.deliveryModel) === null || _this$deliveryModel2 === void 0 ? void 0 : _this$deliveryModel2.selectedUserLocation;
                deliveryFromCountry = deliveryFrom !== null && deliveryFrom !== void 0 && deliveryFrom.countyCode ? deliveryFrom === null || deliveryFrom === void 0 ? void 0 : deliveryFrom.countyCode : deliveryFrom === null || deliveryFrom === void 0 ? void 0 : deliveryFrom.country;
                quoteRequest = {
                  dropOffAddress: {
                    addressLine1: deliveryFrom === null || deliveryFrom === void 0 ? void 0 : deliveryFrom.addressLine1,
                    addressLine2: (_this$deliveryModel3 = this.deliveryModel) === null || _this$deliveryModel3 === void 0 ? void 0 : _this$deliveryModel3.suiteOrApartmentNumber,
                    state: deliveryFrom === null || deliveryFrom === void 0 ? void 0 : deliveryFrom.state,
                    city: deliveryFrom === null || deliveryFrom === void 0 ? void 0 : deliveryFrom.city,
                    zipcode: deliveryFrom === null || deliveryFrom === void 0 ? void 0 : deliveryFrom.zipCode,
                    country: deliveryFromCountry
                  },
                  pickupRestaurantNumber: (_this$deliveryModel4 = this.deliveryModel) === null || _this$deliveryModel4 === void 0 ? void 0 : (_this$deliveryModel4$ = _this$deliveryModel4.deliveryFrom) === null || _this$deliveryModel4$ === void 0 ? void 0 : _this$deliveryModel4$.restaurantNumber,
                  pickupDate: pickupTime.format("MM/DD/YYYY"),
                  pickupTime: pickupTime.format("hh:mm A")
                };
                _context3.prev = 3;
                _context3.t0 = this.deliveryModel;
                _context3.next = 7;
                return DPServices.Delivery.getQuote(pickupTime, quoteRequest);

              case 7:
                _context3.t1 = _context3.sent;

                _context3.t0.setTogoDeliveryQuote.call(_context3.t0, _context3.t1);

                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t2 = _context3["catch"](3); //offer Pickup

                this.deliveryModel.setShowTogoDeliveryUnavailableErrorModal(true);

                if (_context3.t2 instanceof DPServices.Errors.GetQuoteUIError) {
                  (_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$user = _this$rootStore4.user) === null || _this$rootStore4$user === void 0 ? void 0 : _this$rootStore4$user.analyticsModel.dispatchTogoDeliveryErrorEvent(_context3.t2.errors[0].code, _context3.t2.errors[0].message);
                }

              case 15:
                return _context3.abrupt("return", this.deliveryModel.togoDeliveryQuote);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 11]]);
      }));

      function createQuote(_x3) {
        return _createQuote.apply(this, arguments);
      }

      return createQuote;
    }()
  }, {
    key: "fetchTimes",
    value: function () {
      var _fetchTimes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$deliveryModel5,
            _this$deliveryModel5$,
            _this$rootStore$commo,
            _this$rootStore5,
            _this$rootStore5$comm,
            _this$rootStore6,
            _this$rootStore6$deli,
            _this3 = this;

        var isPickup,
            restaurantNum,
            selectedDate,
            restaurantNumber,
            derrivedDate,
            orderId,
            isTogo,
            _this$rootStore7,
            _this$rootStore7$user,
            orderType,
            JWT_TOKEN,
            timesResponse,
            _this$appMessages,
            _this$rootStore8,
            _this$rootStore8$user,
            _e$errors,
            _e$errors$,
            _e$errors2,
            _e$errors2$,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                isPickup = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : false;
                restaurantNum = _args4.length > 1 ? _args4[1] : undefined;
                selectedDate = _args4.length > 2 ? _args4[2] : undefined;
                restaurantNumber = restaurantNum ? restaurantNum : (_this$deliveryModel5 = this.deliveryModel) === null || _this$deliveryModel5 === void 0 ? void 0 : (_this$deliveryModel5$ = _this$deliveryModel5.deliveryFrom) === null || _this$deliveryModel5$ === void 0 ? void 0 : _this$deliveryModel5$.restaurantNumber;
                derrivedDate = selectedDate ? selectedDate : this.timeModel.selectedCalendarDate; //revisit this, send date based on

                orderId = (_this$rootStore$commo = (_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$comm = _this$rootStore5.common) === null || _this$rootStore5$comm === void 0 ? void 0 : _this$rootStore5$comm.orderID) !== null && _this$rootStore$commo !== void 0 ? _this$rootStore$commo : this.deliveryModel.orderId;
                isTogo = (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$deli = _this$rootStore6.delivery) === null || _this$rootStore6$deli === void 0 ? void 0 : _this$rootStore6$deli.isTogo;

                if (!restaurantNumber) {
                  _context4.next = 32;
                  break;
                }

                _context4.prev = 8;
                orderType = 0;

                if (isTogo) {
                  orderType = ORDER_TYPES.TOGO_DELIVERY;
                } else if (isPickup) {
                  orderType = ORDER_TYPES.TOGO_PICKUP;
                } else {
                  orderType = ORDER_TYPES.CATERING_DELIVERY;
                }

                _context4.next = 13;
                return (_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$user = _this$rootStore7.user) === null || _this$rootStore7$user === void 0 ? void 0 : _this$rootStore7$user.getTokenSilentIfLoggedIn();

              case 13:
                JWT_TOKEN = _context4.sent;
                _context4.next = 16;
                return DPServices.Times.getPickupTimes(JWT_TOKEN, restaurantNumber, derrivedDate, orderType, false, orderId);

              case 16:
                timesResponse = _context4.sent;

                if (!timesResponse) {
                  _context4.next = 26;
                  break;
                }

                if (!(timesResponse !== null && timesResponse !== void 0 && timesResponse.donotDeliver)) {
                  _context4.next = 23;
                  break;
                }

                this.deliveryModel.donotDeliver = true;
                return _context4.abrupt("return");

              case 23:
                this.deliveryModel.donotDeliver = false;

              case 24:
                runInAction(function () {
                  _this3.timeModel.setCapacitySlotsResponse(timesResponse);

                  _this3.timeModel.setRecentTimeSelectionFromAPi(UserTypes.ERecentTimeSelectionFromAPI.FETCH_TIME_API);

                  _this3.timeModel.setFetchTimeOrderTypeData = orderType;
                });

                if (timesResponse !== null && timesResponse !== void 0 && timesResponse.capacitySlots) {
                  if (!this.isTogo) {
                    this.advanceDateIfNeeded();
                  }
                }

              case 26:
                _context4.next = 32;
                break;

              case 28:
                _context4.prev = 28;
                _context4.t0 = _context4["catch"](8);

                if (!this.isTogo) {
                  console.log("***-- error in fetch times", _context4.t0);
                  (_this$appMessages = this.appMessages) === null || _this$appMessages === void 0 ? void 0 : _this$appMessages.showError("Error", "Something went wrong");
                }

                if (_context4.t0 instanceof DPServices.Errors.UIError) {
                  (_this$rootStore8 = this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : (_this$rootStore8$user = _this$rootStore8.user) === null || _this$rootStore8$user === void 0 ? void 0 : _this$rootStore8$user.analyticsModel.dispatchTogoDeliveryErrorEvent(_context4.t0 === null || _context4.t0 === void 0 ? void 0 : (_e$errors = _context4.t0.errors) === null || _e$errors === void 0 ? void 0 : (_e$errors$ = _e$errors[0]) === null || _e$errors$ === void 0 ? void 0 : _e$errors$.code, _context4.t0 === null || _context4.t0 === void 0 ? void 0 : (_e$errors2 = _context4.t0.errors) === null || _e$errors2 === void 0 ? void 0 : (_e$errors2$ = _e$errors2[0]) === null || _e$errors2$ === void 0 ? void 0 : _e$errors2$.message);
                }

              case 32:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[8, 28]]);
      }));

      function fetchTimes() {
        return _fetchTimes.apply(this, arguments);
      }

      return fetchTimes;
    }()
  }, {
    key: "advanceDateIfNeeded",
    value: function () {
      var _advanceDateIfNeeded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this$timeModel2, _this$timeModel2$avai;

        var _this$timeModel3;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (((_this$timeModel2 = this.timeModel) === null || _this$timeModel2 === void 0 ? void 0 : (_this$timeModel2$avai = _this$timeModel2.availableSlots) === null || _this$timeModel2$avai === void 0 ? void 0 : _this$timeModel2$avai.length) === 0) {
                  this.timeModel.selectedCalendarDate = moment((_this$timeModel3 = this.timeModel) === null || _this$timeModel3 === void 0 ? void 0 : _this$timeModel3.selectedCalendarDate).add(1, "day").toDate();
                  this.timeModel.selectedTimeSlotFromDD = null;
                  this.fetchTimes();
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function advanceDateIfNeeded() {
        return _advanceDateIfNeeded.apply(this, arguments);
      }

      return advanceDateIfNeeded;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this$rootStore9, _this$rootStore9$plat;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log("***-- delivery store init");

                if (!(((_this$rootStore9 = this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$plat = _this$rootStore9.platformUtil) === null || _this$rootStore9$plat === void 0 ? void 0 : _this$rootStore9$plat.PLATFORM_TYPE) !== PlatformType.APP)) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 4;
                return this.rootStore.platformUtil.hydrateUsingLocalStorage("Delivery", this.deliveryModel);

              case 4:
                console.log("***-- delivery model hydration complete");

              case 5:
                this._processSessionDetails(this.rootStore.user.sessionDetails);

                this._processAppAttributes(this.rootStore.common.appAttributes);

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "searchAddressSuggestions",
    value: function () {
      var _searchAddressSuggestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(searchText) {
        var results, _this$appMessages2;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.deliveryModel.setIsSearchResultLoading(true);
                results = null;
                _context7.prev = 2;

                if (!(searchText && searchText.length > 4)) {
                  _context7.next = 9;
                  break;
                }

                _context7.next = 6;
                return DPServices.Location.getMapboxPlaceSuggestions("", searchText, "OG", false, true);

              case 6:
                results = _context7.sent;
                this.deliveryModel.setAddressSuggestionsData(results);
                this.deliveryModel.setIsSearchResultLoading(false);

              case 9:
                _context7.next = 15;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](2);
                console.log("***-- error in search address suggestions", _context7.t0);
                (_this$appMessages2 = this.appMessages) === null || _this$appMessages2 === void 0 ? void 0 : _this$appMessages2.showError("Error", "Something went wrong");

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[2, 11]]);
      }));

      function searchAddressSuggestions(_x4) {
        return _searchAddressSuggestions.apply(this, arguments);
      }

      return searchAddressSuggestions;
    }()
  }, {
    key: "onDeliveryAddressContinue",
    value: function () {
      var _onDeliveryAddressContinue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var results, _this$timeModel4, _this$timeModel4$date, requestedDate, firstSlot, pickupTime, quote, _this$rootStore10, _this$rootStore10$pla, _this$deliveryModel6, response, pickupLocations, _this$rootStore11, _this$rootStore11$pla, _this$appMessages3;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!this.isTogo) {
                  _context8.next = 27;
                  break;
                }

                this.isDeliveryLoading = true;
                _context8.next = 4;
                return this.getDeliveryRestaurants();

              case 4:
                results = this.deliveryModel.deliveryRestaurantsAvailable;

                if (!(results && results.length > 0)) {
                  _context8.next = 24;
                  break;
                }

                this.deliveryModel.deliveryFrom = results[0];
                this.deliveryModel.isUnableDeliveryLocationPage = false;
                /**
                 * Need to set selectedCalendarDate to same date as fetchTimes requested date
                 * as if there is existing order present from previous day
                 * TimeModel.generateDPSlots use that old date
                 */

                requestedDate = (_this$timeModel4 = this.timeModel) === null || _this$timeModel4 === void 0 ? void 0 : (_this$timeModel4$date = _this$timeModel4.dateTimeAtRestaurantLocationTimezone) === null || _this$timeModel4$date === void 0 ? void 0 : _this$timeModel4$date.toDate();
                this.timeModel.selectedCalendarDate = requestedDate; //fire pickupTime for selected Restaurant

                _context8.next = 12;
                return this.fetchTimes(true, this.deliveryModel.deliveryFrom.restaurantNumber, requestedDate);

              case 12:
                if (!this.timeModel.areSlotsAvailable) {
                  _context8.next = 21;
                  break;
                } //fire Quotes API


                firstSlot = this.timeModel.availableSlots[0];
                pickupTime = moment(firstSlot === null || firstSlot === void 0 ? void 0 : firstSlot.startTimeInMs);
                _context8.next = 17;
                return this.createQuote(pickupTime);

              case 17:
                quote = _context8.sent;

                if (quote && this.deliveryModel.showTogoDeliveryUnavailableErrorModal === false) {
                  (_this$rootStore10 = this.rootStore) === null || _this$rootStore10 === void 0 ? void 0 : (_this$rootStore10$pla = _this$rootStore10.platformUtil) === null || _this$rootStore10$pla === void 0 ? void 0 : _this$rootStore10$pla.navigateToRoute("/delivery/togo-delivery-show-quote");
                }

                _context8.next = 22;
                break;

              case 21:
                (_this$deliveryModel6 = this.deliveryModel) === null || _this$deliveryModel6 === void 0 ? void 0 : _this$deliveryModel6.setShowTogoDeliveryFetchTimesErrorModal(true);

              case 22:
                _context8.next = 25;
                break;

              case 24:
                return _context8.abrupt("return");

              case 25:
                _context8.next = 53;
                break;

              case 27:
                _context8.prev = 27;
                this.isDeliveryLoading = true;
                _context8.next = 31;
                return this.setDeliveryAddress();

              case 31:
                response = _context8.sent;

                if (!((response === null || response === void 0 ? void 0 : response.status) === "error")) {
                  _context8.next = 34;
                  break;
                }

                throw response === null || response === void 0 ? void 0 : response.errorResponse;

              case 34:
                if (!this.deliveryModel.donotDeliver) {
                  _context8.next = 43;
                  break;
                }

                _context8.next = 37;
                return this.getPickupLocations();

              case 37:
                pickupLocations = _context8.sent;
                this.deliveryModel.nearbyRestaurants = pickupLocations;
                this.deliveryModel.isUnableDeliveryLocationPage = true;
                this.deliveryModel.isUnableDeliveryModelOpen = true;
                this.isDeliveryLoading = false;
                return _context8.abrupt("return");

              case 43:
                if (this.deliveryModel.isUnableDeliveryLocationPage) {
                  _context8.next = 47;
                  break;
                }

                (_this$rootStore11 = this.rootStore) === null || _this$rootStore11 === void 0 ? void 0 : (_this$rootStore11$pla = _this$rootStore11.platformUtil) === null || _this$rootStore11$pla === void 0 ? void 0 : _this$rootStore11$pla.navigateToRoute("/delivery/restaurant-date-and-time");
                this.isDeliveryLoading = false;
                return _context8.abrupt("return");

              case 47:
                _context8.next = 53;
                break;

              case 49:
                _context8.prev = 49;
                _context8.t0 = _context8["catch"](27);
                this.isDeliveryLoading = false;
                (_this$appMessages3 = this.appMessages) === null || _this$appMessages3 === void 0 ? void 0 : _this$appMessages3.showError("We're Sorry", "We can't deliver to the provided address");

              case 53:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[27, 49]]);
      }));

      function onDeliveryAddressContinue() {
        return _onDeliveryAddressContinue.apply(this, arguments);
      }

      return onDeliveryAddressContinue;
    }()
  }, {
    key: "setDeliveryAddress",
    value: function () {
      var _setDeliveryAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this$deliveryModel7, _this$rootStore$commo2, _this$rootStore12, _this$rootStore12$com, _this$rootStore13, _this$rootStore13$use, _this$deliveryModel8, _this$deliveryModel9, _this$deliveryModel10;

        var changeId,
            deliveryRestaurantNum,
            _this$deliveryModel$d,
            address,
            orderId,
            JWT_TOKEN,
            results,
            _args9 = arguments;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                changeId = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : null;
                deliveryRestaurantNum = null;

                if (!(changeId === null)) {
                  _context9.next = 10;
                  break;
                }

                _context9.next = 5;
                return this.getDeliveryRestaurants();

              case 5:
                _context9.next = 7;
                return (_this$deliveryModel$d = this.deliveryModel.deliveryFrom) === null || _this$deliveryModel$d === void 0 ? void 0 : _this$deliveryModel$d.restaurantNumber;

              case 7:
                deliveryRestaurantNum = _context9.sent;
                _context9.next = 11;
                break;

              case 10:
                //If changing Restaurant, use new ID instead
                deliveryRestaurantNum = changeId;

              case 11:
                if (deliveryRestaurantNum) {
                  _context9.next = 13;
                  break;
                }

                return _context9.abrupt("return", null);

              case 13:
                //Retrieve Address from Model and set delivery address
                address = (_this$deliveryModel7 = this.deliveryModel) === null || _this$deliveryModel7 === void 0 ? void 0 : _this$deliveryModel7.selectedUserLocation; //Retrieve Order Id from Session if exists, otherwise Retrieve from Delivery Model

                orderId = (_this$rootStore$commo2 = (_this$rootStore12 = this.rootStore) === null || _this$rootStore12 === void 0 ? void 0 : (_this$rootStore12$com = _this$rootStore12.common) === null || _this$rootStore12$com === void 0 ? void 0 : _this$rootStore12$com.orderID) !== null && _this$rootStore$commo2 !== void 0 ? _this$rootStore$commo2 : this.deliveryModel.orderId;
                _context9.next = 17;
                return (_this$rootStore13 = this.rootStore) === null || _this$rootStore13 === void 0 ? void 0 : (_this$rootStore13$use = _this$rootStore13.user) === null || _this$rootStore13$use === void 0 ? void 0 : _this$rootStore13$use.getTokenSilentIfLoggedIn();

              case 17:
                JWT_TOKEN = _context9.sent;
                results = DPServices.Restaurant.setDeliveryAddress({
                  addressLine1: address.addressLine1,
                  city: address.city,
                  state: address.state,
                  zipcode: address.zipCode,
                  country: address.countyCode || address.country,
                  // countyCode for map box and country for sessionDetails
                  addressLine2: (_this$deliveryModel8 = this.deliveryModel) === null || _this$deliveryModel8 === void 0 ? void 0 : _this$deliveryModel8.suiteOrApartmentNumber,
                  companyName: (_this$deliveryModel9 = this.deliveryModel) === null || _this$deliveryModel9 === void 0 ? void 0 : _this$deliveryModel9.otherDetails,
                  type: (_this$deliveryModel10 = this.deliveryModel) === null || _this$deliveryModel10 === void 0 ? void 0 : _this$deliveryModel10.selectedAddressType,
                  restaurantNum: Number(deliveryRestaurantNum),
                  orderId: orderId
                }, JWT_TOKEN); //Retrieve order ID from response and set in Model

                _context9.next = 21;
                return results;

              case 21:
                this.deliveryModel.orderId = _context9.sent.orderId;
                _context9.next = 24;
                return this.fetchTimes(false, deliveryRestaurantNum, null);

              case 24:
                return _context9.abrupt("return", results);

              case 25:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function setDeliveryAddress() {
        return _setDeliveryAddress.apply(this, arguments);
      }

      return setDeliveryAddress;
    }()
  }, {
    key: "getDeliveryRestaurants",
    value: function () {
      var _getDeliveryRestaurants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _this$deliveryModel11, _this$deliveryModel12, _this$deliveryModel13, coordsArray, address, _this$deliveryModel14, _this$deliveryModel15, _this$deliveryModel16, deliveryLocationParams, pickupLocationParams, results, _this$timeModel5, _this$rootStore$user2, analyticsPayload, _this$rootStore14, _this$rootStore14$use, pickupLocations, _this$appMessages4, _this$rootStore15, _this$rootStore15$use, _e$errors3, _e$errors3$, _e$errors4, _e$errors4$;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                this.isDeliveryLoading = true;
                coordsArray = (_this$deliveryModel11 = this.deliveryModel) === null || _this$deliveryModel11 === void 0 ? void 0 : (_this$deliveryModel12 = _this$deliveryModel11.selectedUserLocationCoordinates) === null || _this$deliveryModel12 === void 0 ? void 0 : _this$deliveryModel12.split(",");
                address = (_this$deliveryModel13 = this.deliveryModel) === null || _this$deliveryModel13 === void 0 ? void 0 : _this$deliveryModel13.selectedUserLocation;

                if (!(coordsArray && address)) {
                  _context10.next = 29;
                  break;
                }

                deliveryLocationParams = {
                  addressLine1: address.addressLine1,
                  city: address.city,
                  state: address.state,
                  zipcode: address.zipCode,
                  country: address.countyCode || address.country,
                  // countyCode for map box and country for sessionDetails
                  addressLine2: (_this$deliveryModel14 = this.deliveryModel) === null || _this$deliveryModel14 === void 0 ? void 0 : _this$deliveryModel14.suiteOrApartmentNumber,
                  companyName: (_this$deliveryModel15 = this.deliveryModel) === null || _this$deliveryModel15 === void 0 ? void 0 : _this$deliveryModel15.otherDetails,
                  type: (_this$deliveryModel16 = this.deliveryModel) === null || _this$deliveryModel16 === void 0 ? void 0 : _this$deliveryModel16.selectedAddressType,
                  latitude: Number(coordsArray[0]),
                  longitude: Number(coordsArray[1]),
                  orderType: this.isTogo ? ORDER_TYPES.TOGO_DELIVERY : ORDER_TYPES.CATERING_DELIVERY
                };
                pickupLocationParams = {
                  latitude: Number(coordsArray[0]),
                  longitude: Number(coordsArray[1]),
                  resultsPerPage: 50
                };
                _context10.next = 9;
                return DPServices.Restaurant.getDeliveryRestaurants(deliveryLocationParams, pickupLocationParams, this.isTogo);

              case 9:
                results = _context10.sent;
                this.deliveryModel.isDeliveryRestaurantApiCallStatus = true;
                this.deliveryModel.deliveryRestaurantsAvailable = results === null || results === void 0 ? void 0 : results.deliveryLocations;
                this.deliveryModel.nearbyRestaurants = results === null || results === void 0 ? void 0 : results.pickUpLocations;

                if (!(results.deliveryResultsCount > 0)) {
                  _context10.next = 21;
                  break;
                }

                this.deliveryModel.deliveryFrom = results.deliveryLocations[0];
                this.deliveryModel.isUnableDeliveryLocationPage = false; //Dispatch initial event

                if (this.deliveryModel.deliveryFrom) {
                  analyticsPayload = {
                    formType: this.isTogo ? "Togo Delivery Address" : "Catering Delivery Address",
                    address: address
                  };
                  (_this$rootStore$user2 = this.rootStore.user) === null || _this$rootStore$user2 === void 0 ? void 0 : _this$rootStore$user2.analyticsModel.dispatchFormSubmitEvent(analyticsPayload); //Reset Dirty Form Flag for Second Catering Form

                  if (!this.isTogo) {
                    this.rootStore.user.analyticsModel.isDeliveryFormDirty = false;
                  }
                }

                if (moment().isSame(moment((_this$timeModel5 = this.timeModel) === null || _this$timeModel5 === void 0 ? void 0 : _this$timeModel5.selectedCalendarDate), "day")) {
                  if (!this.isTogo) {
                    this.timeModel.selectedCalendarDate = moment().add(1, "day").toDate();
                    this.timeModel.selectedTimeSlotFromDD = null;
                  }
                }

                this.isDeliveryLoading = false;
                _context10.next = 29;
                break;

              case 21:
                _context10.next = 23;
                return this.getPickupLocations();

              case 23:
                pickupLocations = _context10.sent;
                this.isDeliveryLoading = false;
                this.deliveryModel.nearbyRestaurants = pickupLocations;
                this.deliveryModel.isUnableDeliveryLocationPage = true; //Delivery API returns 200 but no results

                this.deliveryModel.isUnableDeliveryModelOpen = true;
                (_this$rootStore14 = this.rootStore) === null || _this$rootStore14 === void 0 ? void 0 : (_this$rootStore14$use = _this$rootStore14.user) === null || _this$rootStore14$use === void 0 ? void 0 : _this$rootStore14$use.analyticsModel.dispatchTogoDeliveryErrorEvent("Unable to Deliver", "We are unable to deliver to the address entered");

              case 29:
                _context10.next = 36;
                break;

              case 31:
                _context10.prev = 31;
                _context10.t0 = _context10["catch"](0);
                console.log("***-- error in the getDeliveryRestaurants", _context10.t0);
                this.isDeliveryLoading = false;

                if (!this.isTogo) {
                  (_this$appMessages4 = this.appMessages) === null || _this$appMessages4 === void 0 ? void 0 : _this$appMessages4.showError("Error", "Something went wrong");
                } else {
                  this.deliveryModel.isUnableDeliveryModelOpen = true;

                  if (_context10.t0 instanceof DPServices.Errors.UIError) {
                    (_this$rootStore15 = this.rootStore) === null || _this$rootStore15 === void 0 ? void 0 : (_this$rootStore15$use = _this$rootStore15.user) === null || _this$rootStore15$use === void 0 ? void 0 : _this$rootStore15$use.analyticsModel.dispatchTogoDeliveryErrorEvent(_context10.t0 === null || _context10.t0 === void 0 ? void 0 : (_e$errors3 = _context10.t0.errors) === null || _e$errors3 === void 0 ? void 0 : (_e$errors3$ = _e$errors3[0]) === null || _e$errors3$ === void 0 ? void 0 : _e$errors3$.code, _context10.t0 === null || _context10.t0 === void 0 ? void 0 : (_e$errors4 = _context10.t0.errors) === null || _e$errors4 === void 0 ? void 0 : (_e$errors4$ = _e$errors4[0]) === null || _e$errors4$ === void 0 ? void 0 : _e$errors4$.message);
                  }
                }

              case 36:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 31]]);
      }));

      function getDeliveryRestaurants() {
        return _getDeliveryRestaurants.apply(this, arguments);
      }

      return getDeliveryRestaurants;
    }()
  }, {
    key: "getPickupLocations",
    value: function () {
      var _getPickupLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this$deliveryModel17;

        var coordsArray, pickupLocations, coordsObj, resultObj, finalLocResults;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                coordsArray = (_this$deliveryModel17 = this.deliveryModel) === null || _this$deliveryModel17 === void 0 ? void 0 : _this$deliveryModel17.selectedUserLocationCoordinates.split(", ");
                pickupLocations = this.deliveryModel.nearbyRestaurants;
                coordsObj = {
                  latitude: Number(coordsArray[0]),
                  longitude: Number(coordsArray[1]),
                  altitude: null,
                  accuracy: null,
                  altitudeAccuracy: null,
                  heading: null,
                  speed: null
                };
                _context11.next = 5;
                return fetchDistances(coordsObj, pickupLocations);

              case 5:
                resultObj = _context11.sent;
                finalLocResults = pickupLocations === null || pickupLocations === void 0 ? void 0 : pickupLocations.map(function (result) {
                  var temp = result;
                  temp.mapBoxDistance = resultObj[result === null || result === void 0 ? void 0 : result.restaurantNumber];
                  return temp;
                });
                return _context11.abrupt("return", orderBy(finalLocResults, "mapBoxDistance", "asc"));

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getPickupLocations() {
        return _getPickupLocations.apply(this, arguments);
      }

      return getPickupLocations;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "_processAppAttributes",
    value: function () {
      var _processAppAttributes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(appAttributes) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this.deliveryModel.setAppAttributes(appAttributes);
                this.timeModel.setAppAttributes(appAttributes);

              case 2:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function _processAppAttributes(_x5) {
        return _processAppAttributes2.apply(this, arguments);
      }

      return _processAppAttributes;
    }()
  }, {
    key: "setDeliveryTime",
    value: function () {
      var _setDeliveryTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var _this$deliveryModel18, _this$rootStore$commo3, _this$rootStore16, _this$rootStore16$com, _this$rootStore17, _this$rootStore17$use, _this$timeModel6, _this$timeModel7, _this$timeModel7$sele, _this$deliveryModel19, _selectedDeliveryRest, _this$timeModel8, _this$timeModel9, _this$timeModel9$sele, _this$deliveryModel20, _this$rootStore$user3, _this$rootStore18, _this$rootStore18$use, _this$rootStore$platf, selectedDeliveryRestaurant, orderId, JWT_TOKEN, analyticsPayload, _this$appMessages5, result;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                selectedDeliveryRestaurant = (_this$deliveryModel18 = this.deliveryModel) === null || _this$deliveryModel18 === void 0 ? void 0 : _this$deliveryModel18.deliveryFrom;
                this.isDeliveryLoading = true;
                orderId = (_this$rootStore$commo3 = (_this$rootStore16 = this.rootStore) === null || _this$rootStore16 === void 0 ? void 0 : (_this$rootStore16$com = _this$rootStore16.common) === null || _this$rootStore16$com === void 0 ? void 0 : _this$rootStore16$com.orderID) !== null && _this$rootStore$commo3 !== void 0 ? _this$rootStore$commo3 : this.deliveryModel.orderId;
                _context15.next = 6;
                return (_this$rootStore17 = this.rootStore) === null || _this$rootStore17 === void 0 ? void 0 : (_this$rootStore17$use = _this$rootStore17.user) === null || _this$rootStore17$use === void 0 ? void 0 : _this$rootStore17$use.getTokenSilentIfLoggedIn();

              case 6:
                JWT_TOKEN = _context15.sent;
                _context15.next = 9;
                return DPServices.Restaurant.setDeliveryTime(formatDate((_this$timeModel6 = this.timeModel) === null || _this$timeModel6 === void 0 ? void 0 : _this$timeModel6.selectedCalendarDate), (_this$timeModel7 = this.timeModel) === null || _this$timeModel7 === void 0 ? void 0 : (_this$timeModel7$sele = _this$timeModel7.selectedTimeSlot) === null || _this$timeModel7$sele === void 0 ? void 0 : _this$timeModel7$sele.startTime, (_this$deliveryModel19 = this.deliveryModel) === null || _this$deliveryModel19 === void 0 ? void 0 : _this$deliveryModel19.noOfGuests, selectedDeliveryRestaurant === null || selectedDeliveryRestaurant === void 0 ? void 0 : selectedDeliveryRestaurant.duration, selectedDeliveryRestaurant === null || selectedDeliveryRestaurant === void 0 ? void 0 : (_selectedDeliveryRest = selectedDeliveryRestaurant.miles) === null || _selectedDeliveryRest === void 0 ? void 0 : _selectedDeliveryRest.toString(), orderId, JWT_TOKEN);

              case 9:
                try {
                  if (this.rootStore.menuList) {
                    this.rootStore.menuList.timeModel.setRecentTimeSelectionFromAPi(null);
                    this.rootStore.menuList.timeModel.resetTimeModel();
                    this.rootStore.menuList.timeModel.setPickupTimeResponse(null);
                    this.rootStore.menuList.timeModel.currentRequestedDate = null;
                  }
                } catch (e) {}

                analyticsPayload = {
                  formType: "Catering Delivery Date Time",
                  date: formatDate((_this$timeModel8 = this.timeModel) === null || _this$timeModel8 === void 0 ? void 0 : _this$timeModel8.selectedCalendarDate),
                  time: (_this$timeModel9 = this.timeModel) === null || _this$timeModel9 === void 0 ? void 0 : (_this$timeModel9$sele = _this$timeModel9.selectedTimeSlot) === null || _this$timeModel9$sele === void 0 ? void 0 : _this$timeModel9$sele.startTime,
                  numberOfGuests: (_this$deliveryModel20 = this.deliveryModel) === null || _this$deliveryModel20 === void 0 ? void 0 : _this$deliveryModel20.noOfGuests
                };
                (_this$rootStore$user3 = this.rootStore.user) === null || _this$rootStore$user3 === void 0 ? void 0 : _this$rootStore$user3.analyticsModel.dispatchFormSubmitEvent(analyticsPayload);
                _context15.next = 14;
                return (_this$rootStore18 = this.rootStore) === null || _this$rootStore18 === void 0 ? void 0 : (_this$rootStore18$use = _this$rootStore18.user) === null || _this$rootStore18$use === void 0 ? void 0 : _this$rootStore18$use.updateSession();

              case 14:
                (_this$rootStore$platf = this.rootStore.platformUtil) === null || _this$rootStore$platf === void 0 ? void 0 : _this$rootStore$platf.navigateToRoute("/menu");
                this.isDeliveryLoading = false;
                _context15.next = 25;
                break;

              case 18:
                _context15.prev = 18;
                _context15.t0 = _context15["catch"](0);
                this.isDeliveryLoading = false;
                _context15.next = 23;
                return this.parseDeliveryAPIErrors(_context15.t0.response.data);

              case 23:
                result = _context15.sent;
                (_this$appMessages5 = this.appMessages) === null || _this$appMessages5 === void 0 ? void 0 : _this$appMessages5.showError("Error", result.reason);

              case 25:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 18]]);
      }));

      function setDeliveryTime() {
        return _setDeliveryTime.apply(this, arguments);
      }

      return setDeliveryTime;
    }()
  }, {
    key: "createExternalDelivery",
    value: function () {
      var _createExternalDelivery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(deliveryTime) {
        var _this$deliveryModel21, _this$deliveryModel22, _this$rootStore$commo4, _this$rootStore19, _this$rootStore19$com, _this$deliveryModel23, _this$deliveryModel24, _this$deliveryModel25, _this$deliveryModel26, _deliveryRequest$quot;

        var dropoffAddress, dropOffAddressState, dropOffAddressCountry, togoDeliveryQuote, orderId, deliveryRequest, analyticsPayload, _this$rootStore20, _this$rootStore20$use, _e$errors5, _e$errors5$, _e$errors6, _e$errors6$;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                dropoffAddress = (_this$deliveryModel21 = this.deliveryModel) === null || _this$deliveryModel21 === void 0 ? void 0 : _this$deliveryModel21.selectedUserLocation; //If mapbox does not return State Code, use State Name

                dropOffAddressState = dropoffAddress !== null && dropoffAddress !== void 0 && dropoffAddress.stateCode ? dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.stateCode : dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.state; //If mapbox does not return Country Code, use Country String

                dropOffAddressCountry = dropoffAddress !== null && dropoffAddress !== void 0 && dropoffAddress.countyCode ? dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.countyCode : dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.country;
                togoDeliveryQuote = (_this$deliveryModel22 = this.deliveryModel) === null || _this$deliveryModel22 === void 0 ? void 0 : _this$deliveryModel22.togoDeliveryQuote;
                orderId = (_this$rootStore$commo4 = (_this$rootStore19 = this.rootStore) === null || _this$rootStore19 === void 0 ? void 0 : (_this$rootStore19$com = _this$rootStore19.common) === null || _this$rootStore19$com === void 0 ? void 0 : _this$rootStore19$com.orderID) !== null && _this$rootStore$commo4 !== void 0 ? _this$rootStore$commo4 : this.deliveryModel.orderId;
                deliveryRequest = {
                  deliveryDate: deliveryTime.format("MM/DD/YYYY"),
                  deliveryTime: deliveryTime.format("hh:mm A"),
                  restaurantNum: (_this$deliveryModel23 = this.deliveryModel) === null || _this$deliveryModel23 === void 0 ? void 0 : (_this$deliveryModel24 = _this$deliveryModel23.deliveryFrom) === null || _this$deliveryModel24 === void 0 ? void 0 : _this$deliveryModel24.restaurantNumber,
                  quote: {
                    created: togoDeliveryQuote.created,
                    expires: togoDeliveryQuote.expires,
                    quoteId: togoDeliveryQuote.quoteId,
                    dropOffEta: togoDeliveryQuote.dropOffEta,
                    dropOffDeadline: togoDeliveryQuote.dropOffDeadline,
                    deliveryFee: togoDeliveryQuote.deliveryFee
                  },
                  dropOffAddress: {
                    addressLine1: dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.addressLine1,
                    addressLine2: (_this$deliveryModel25 = this.deliveryModel) === null || _this$deliveryModel25 === void 0 ? void 0 : _this$deliveryModel25.suiteOrApartmentNumber,
                    state: dropOffAddressState,
                    city: dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.city,
                    zipcode: dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.zipCode,
                    country: dropOffAddressCountry
                  },
                  validateCartItems: true,
                  orderId: orderId
                };
                analyticsPayload = {
                  timeEstimate: (_this$deliveryModel26 = this.deliveryModel) === null || _this$deliveryModel26 === void 0 ? void 0 : _this$deliveryModel26.timeEstimate,
                  address: deliveryRequest === null || deliveryRequest === void 0 ? void 0 : deliveryRequest.dropOffAddress,
                  deliveryDate: deliveryRequest === null || deliveryRequest === void 0 ? void 0 : deliveryRequest.deliveryDate,
                  quoteId: deliveryRequest === null || deliveryRequest === void 0 ? void 0 : (_deliveryRequest$quot = deliveryRequest.quote) === null || _deliveryRequest$quot === void 0 ? void 0 : _deliveryRequest$quot.quoteId
                };
                _context16.prev = 7;
                _context16.t0 = this.deliveryModel;
                _context16.next = 11;
                return DPServices.Delivery.createExternalDelivery(deliveryRequest);

              case 11:
                _context16.t1 = _context16.sent;

                _context16.t0.setTogoDeliveryOrderDetails.call(_context16.t0, _context16.t1);

                _context16.next = 19;
                break;

              case 15:
                _context16.prev = 15;
                _context16.t2 = _context16["catch"](7); //offer Pickup

                this.deliveryModel.setShowTogoDeliveryUnavailableErrorModal(true);

                if (_context16.t2 instanceof DPServices.Errors.UIError) {
                  (_this$rootStore20 = this.rootStore) === null || _this$rootStore20 === void 0 ? void 0 : (_this$rootStore20$use = _this$rootStore20.user) === null || _this$rootStore20$use === void 0 ? void 0 : _this$rootStore20$use.analyticsModel.dispatchTogoDeliveryErrorEvent(_context16.t2 === null || _context16.t2 === void 0 ? void 0 : (_e$errors5 = _context16.t2.errors) === null || _e$errors5 === void 0 ? void 0 : (_e$errors5$ = _e$errors5[0]) === null || _e$errors5$ === void 0 ? void 0 : _e$errors5$.code, _context16.t2 === null || _context16.t2 === void 0 ? void 0 : (_e$errors6 = _context16.t2.errors) === null || _e$errors6 === void 0 ? void 0 : (_e$errors6$ = _e$errors6[0]) === null || _e$errors6$ === void 0 ? void 0 : _e$errors6$.message);
                }

              case 19:
                return _context16.abrupt("return", this.deliveryModel.togoDeliveryOrderDetails);

              case 20:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[7, 15]]);
      }));

      function createExternalDelivery(_x6) {
        return _createExternalDelivery.apply(this, arguments);
      }

      return createExternalDelivery;
    }()
  }, {
    key: "confirmTogoDelivery",
    value: function () {
      var _confirmTogoDelivery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var _this$rootStore21, _this$rootStore21$use;

        var firstSlot, pickupTime, externalDeliveryDetails, _this$rootStore$platf2;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this.isDeliveryLoading = true; //submit external delivery

                firstSlot = this.timeModel.availableSlots[0];
                pickupTime = moment(firstSlot === null || firstSlot === void 0 ? void 0 : firstSlot.startTimeInMs);
                _context17.next = 5;
                return this.createExternalDelivery(pickupTime);

              case 5:
                externalDeliveryDetails = _context17.sent;
                _context17.next = 8;
                return (_this$rootStore21 = this.rootStore) === null || _this$rootStore21 === void 0 ? void 0 : (_this$rootStore21$use = _this$rootStore21.user) === null || _this$rootStore21$use === void 0 ? void 0 : _this$rootStore21$use.updateSession();

              case 8:
                this.isDeliveryLoading = false;

                if (externalDeliveryDetails && this.deliveryModel.showTogoDeliveryUnavailableErrorModal === false) {
                  (_this$rootStore$platf2 = this.rootStore.platformUtil) === null || _this$rootStore$platf2 === void 0 ? void 0 : _this$rootStore$platf2.navigateToRoute("/menu");
                }

              case 10:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function confirmTogoDelivery() {
        return _confirmTogoDelivery.apply(this, arguments);
      }

      return confirmTogoDelivery;
    }()
  }, {
    key: "changeDeliveryRestaurant",
    value: function () {
      var _changeDeliveryRestaurant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(item) {
        var _this$deliveryModel27, _this$deliveryModel28;

        var _this$timeModel10;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (item.restaurantNumber !== ((_this$deliveryModel27 = this.deliveryModel) === null || _this$deliveryModel27 === void 0 ? void 0 : (_this$deliveryModel28 = _this$deliveryModel27.deliveryFrom) === null || _this$deliveryModel28 === void 0 ? void 0 : _this$deliveryModel28.restaurantNumber)) {
                  this.deliveryModel.deliveryFrom = item;

                  if (moment().isSame(moment((_this$timeModel10 = this.timeModel) === null || _this$timeModel10 === void 0 ? void 0 : _this$timeModel10.selectedCalendarDate), "day")) {
                    this.timeModel.selectedCalendarDate = moment().add(1, "day").toDate();
                    this.timeModel.selectedTimeSlotFromDD = null;
                  }

                  this.setDeliveryAddress(this.deliveryModel.deliveryFrom.restaurantNumber);
                }

                this.deliveryModel.isSelectRestaurantPopupOpen = false;

              case 2:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function changeDeliveryRestaurant(_x7) {
        return _changeDeliveryRestaurant.apply(this, arguments);
      }

      return changeDeliveryRestaurant;
    }()
  }, {
    key: "loadDeliveryDateAndTimePage",
    value: function () {
      var _loadDeliveryDateAndTimePage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var _this$deliveryModel29;

        var _this$timeModel11, _this$timeModel11$ava, pickupLocations;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (!(!((_this$deliveryModel29 = this.deliveryModel) !== null && _this$deliveryModel29 !== void 0 && _this$deliveryModel29.isDeliveryRestaurantApiCallStatus) && !this.isTogo)) {
                  _context19.next = 18;
                  break;
                }

                this.isDeliveryPageLoading = true;
                console.log("***-- making the fet delivery restaurants api call");
                _context19.next = 5;
                return this.getDeliveryRestaurants();

              case 5:
                if (!(((_this$timeModel11 = this.timeModel) === null || _this$timeModel11 === void 0 ? void 0 : (_this$timeModel11$ava = _this$timeModel11.availableSlots) === null || _this$timeModel11$ava === void 0 ? void 0 : _this$timeModel11$ava.length) === 0)) {
                  _context19.next = 8;
                  break;
                }

                _context19.next = 8;
                return this.fetchTimes();

              case 8:
                if (!this.deliveryModel.donotDeliver) {
                  _context19.next = 15;
                  break;
                }

                this.deliveryModel.isUnableDeliveryLocationPage = true;
                this.deliveryModel.isUnableDeliveryModelOpen = true;
                _context19.next = 13;
                return this.getPickupLocations();

              case 13:
                pickupLocations = _context19.sent;
                this.deliveryModel.nearbyRestaurants = pickupLocations;

              case 15:
                this.isDeliveryPageLoading = false;
                _context19.next = 19;
                break;

              case 18:
                this.isDeliveryPageLoading = false;

              case 19:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function loadDeliveryDateAndTimePage() {
        return _loadDeliveryDateAndTimePage.apply(this, arguments);
      }

      return loadDeliveryDateAndTimePage;
    }()
  }, {
    key: "deliveryToPickupSwitch",
    value: function () {
      var _deliveryToPickupSwitch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(restaurantNumber) {
        var _this$timeModel$avail, _this$rootStore$commo5, _this$rootStore22, _this$rootStore22$com, _this$rootStore23, _this$rootStore23$use, startTime, orderId, jwtToken;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                this.isDeliveryLoading = true;
                _context20.next = 4;
                return this.fetchTimes(true, restaurantNumber, moment().toDate());

              case 4:
                startTime = (_this$timeModel$avail = this.timeModel.availableSlots[0]) === null || _this$timeModel$avail === void 0 ? void 0 : _this$timeModel$avail.startTimeInMs;
                orderId = (_this$rootStore$commo5 = (_this$rootStore22 = this.rootStore) === null || _this$rootStore22 === void 0 ? void 0 : (_this$rootStore22$com = _this$rootStore22.common) === null || _this$rootStore22$com === void 0 ? void 0 : _this$rootStore22$com.orderID) !== null && _this$rootStore$commo5 !== void 0 ? _this$rootStore$commo5 : this.deliveryModel.orderId;
                _context20.next = 8;
                return (_this$rootStore23 = this.rootStore) === null || _this$rootStore23 === void 0 ? void 0 : (_this$rootStore23$use = _this$rootStore23.user) === null || _this$rootStore23$use === void 0 ? void 0 : _this$rootStore23$use.getTokenSilentIfLoggedIn();

              case 8:
                jwtToken = _context20.sent;

                if (!startTime) {
                  _context20.next = 18;
                  break;
                }

                _context20.next = 12;
                return DPServices.Times.setOrderRestaurantAndPickupTime(moment(startTime).toDate(), restaurantNumber, orderId, jwtToken, false, false);

              case 12:
                _context20.next = 14;
                return this.rootStore.user.updateSession();

              case 14:
                this.isDeliveryLoading = false;
                this.rootStore.platformUtil.navigateToRoute("/menu");
                _context20.next = 20;
                break;

              case 18:
                this.isDeliveryLoading = false;

                if (this.isTogo) {
                  this.rootStore.platformUtil.navigateToRoute("/menu");
                } else {
                  this.appMessages.showError("Error", "No pickup time available.");
                }

              case 20:
                _context20.next = 26;
                break;

              case 22:
                _context20.prev = 22;
                _context20.t0 = _context20["catch"](0);
                this.isDeliveryLoading = false;
                this.appMessages.showError("Something went wrong", "Delivery to pickup switch failed");

              case 26:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this, [[0, 22]]);
      }));

      function deliveryToPickupSwitch(_x8) {
        return _deliveryToPickupSwitch.apply(this, arguments);
      }

      return deliveryToPickupSwitch;
    }()
    /**
    * As location-time not make location sticky now without OrderID (OrderType 2 page without location in context)
    * calling this function to make location sticky on "Order Pickup"
    * @param restaurantNum
    */

  }, {
    key: "onOrderPickupPress",
    value: function () {
      var _onOrderPickupPress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _this$deliveryModel30, _this$rootStore$commo6, _this$rootStore24, _this$rootStore24$com, _this$rootStore25, _this$rootStore25$use, restaurantNumber, orderId, jwtToken, _this$rootStore26, _this$rootStore26$use, _this$rootStore26$use2, _this$rootStore26$use3, _this$timeModel$avail2, startTime;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                this.isDeliverySwitchLoading = true;
                _context21.prev = 1;
                restaurantNumber = (_this$deliveryModel30 = this.deliveryModel) === null || _this$deliveryModel30 === void 0 ? void 0 : _this$deliveryModel30.previousRestaurantNumber;
                orderId = (_this$rootStore$commo6 = (_this$rootStore24 = this.rootStore) === null || _this$rootStore24 === void 0 ? void 0 : (_this$rootStore24$com = _this$rootStore24.common) === null || _this$rootStore24$com === void 0 ? void 0 : _this$rootStore24$com.orderID) !== null && _this$rootStore$commo6 !== void 0 ? _this$rootStore$commo6 : this.deliveryModel.orderId;
                _context21.next = 6;
                return (_this$rootStore25 = this.rootStore) === null || _this$rootStore25 === void 0 ? void 0 : (_this$rootStore25$use = _this$rootStore25.user) === null || _this$rootStore25$use === void 0 ? void 0 : _this$rootStore25$use.getTokenSilentIfLoggedIn();

              case 6:
                jwtToken = _context21.sent;

                if (!restaurantNumber) {
                  _context21.next = 20;
                  break;
                }

                _context21.next = 10;
                return this.fetchTimes(true, (_this$rootStore26 = this.rootStore) === null || _this$rootStore26 === void 0 ? void 0 : (_this$rootStore26$use = _this$rootStore26.user) === null || _this$rootStore26$use === void 0 ? void 0 : (_this$rootStore26$use2 = _this$rootStore26$use.sessionDetails) === null || _this$rootStore26$use2 === void 0 ? void 0 : (_this$rootStore26$use3 = _this$rootStore26$use2.restaurantDetails) === null || _this$rootStore26$use3 === void 0 ? void 0 : _this$rootStore26$use3.restaurantNumber, moment().toDate());

              case 10:
                startTime = (_this$timeModel$avail2 = this.timeModel.availableSlots[0]) === null || _this$timeModel$avail2 === void 0 ? void 0 : _this$timeModel$avail2.startTimeInMs;

                if (!startTime) {
                  _context21.next = 18;
                  break;
                }

                _context21.next = 14;
                return DPServices.Times.setOrderRestaurantAndPickupTime(moment(startTime).toDate(), restaurantNumber, orderId, jwtToken, false, false);

              case 14:
                _context21.next = 16;
                return this.rootStore.user.updateSession();

              case 16:
                _context21.next = 20;
                break;

              case 18:
                this.isDeliveryLoading = false;
                this.appMessages.showError("Error", "No pickup time available.");

              case 20:
                this.isDeliverySwitchLoading = false;

                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
                  this.rootStore.platformUtil.navigateToRoute("/home");
                } else {
                  this.rootStore.platformUtil.navigateToRoute("/order-online?orderType=delivery");
                }

                _context21.next = 28;
                break;

              case 24:
                _context21.prev = 24;
                _context21.t0 = _context21["catch"](1);
                this.isDeliveryLoading = false;
                this.appMessages.showError("Something went wrong", "Delivery to pickup switch failed");

              case 28:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this, [[1, 24]]);
      }));

      function onOrderPickupPress() {
        return _onOrderPickupPress.apply(this, arguments);
      }

      return onOrderPickupPress;
    }()
  }, {
    key: "parseDeliveryAPIErrors",
    value: function () {
      var _parseDeliveryAPIErrors = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(errorObj) {
        var _errorObj$errors$0$er, _errorObj$errors;

        var result;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                result = {
                  status: "ERROR",
                  reason: (_errorObj$errors$0$er = errorObj === null || errorObj === void 0 ? void 0 : (_errorObj$errors = errorObj.errors) === null || _errorObj$errors === void 0 ? void 0 : _errorObj$errors[0].errorMessage) !== null && _errorObj$errors$0$er !== void 0 ? _errorObj$errors$0$er : "Something went wrong.",
                  faultCode: errorObj === null || errorObj === void 0 ? void 0 : errorObj.statusCode
                };
                return _context22.abrupt("return", result);

              case 2:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      function parseDeliveryAPIErrors(_x9) {
        return _parseDeliveryAPIErrors.apply(this, arguments);
      }

      return parseDeliveryAPIErrors;
    }()
  }, {
    key: "dispatchDeliveryFormStartEvent",
    value: function () {
      var _dispatchDeliveryFormStartEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(formName) {
        var _this$rootStore27, _this$rootStore27$use, _this$rootStore27$use2, _this$rootStore28, _this$rootStore28$use, _this$rootStore28$use2;

        var _this$rootStore29, _this$rootStore29$use, payload;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (!((_this$rootStore27 = this.rootStore) !== null && _this$rootStore27 !== void 0 && (_this$rootStore27$use = _this$rootStore27.user) !== null && _this$rootStore27$use !== void 0 && (_this$rootStore27$use2 = _this$rootStore27$use.analyticsModel) !== null && _this$rootStore27$use2 !== void 0 && _this$rootStore27$use2.isDeliveryFormDirty) && !((_this$rootStore28 = this.rootStore) !== null && _this$rootStore28 !== void 0 && (_this$rootStore28$use = _this$rootStore28.user) !== null && _this$rootStore28$use !== void 0 && (_this$rootStore28$use2 = _this$rootStore28$use.analyticsModel) !== null && _this$rootStore28$use2 !== void 0 && _this$rootStore28$use2.isEditDelivery)) {
                  payload = {
                    formType: formName
                  };
                  (_this$rootStore29 = this.rootStore) === null || _this$rootStore29 === void 0 ? void 0 : (_this$rootStore29$use = _this$rootStore29.user) === null || _this$rootStore29$use === void 0 ? void 0 : _this$rootStore29$use.analyticsModel.dispatchFormStartEvent(payload);
                }

                this.rootStore.user.analyticsModel.isDeliveryFormDirty = true;

              case 2:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function dispatchDeliveryFormStartEvent(_x10) {
        return _dispatchDeliveryFormStartEvent.apply(this, arguments);
      }

      return dispatchDeliveryFormStartEvent;
    }()
  }, {
    key: "dispatchTogoDeliveryQuote",
    value: function dispatchTogoDeliveryQuote() {
      var _this$deliveryModel31, _this$deliveryModel32, _this$deliveryModel33, _this$deliveryModel34, _this$deliveryModel35, _this$rootStore$user4;

      var dropoffAddress = (_this$deliveryModel31 = this.deliveryModel) === null || _this$deliveryModel31 === void 0 ? void 0 : _this$deliveryModel31.selectedUserLocation; //If mapbox does not return State Code, use State Name

      var dropOffAddressState = dropoffAddress !== null && dropoffAddress !== void 0 && dropoffAddress.stateCode ? dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.stateCode : dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.state; //If mapbox does not return Country Code, use Country String

      var dropOffAddressCountry = dropoffAddress !== null && dropoffAddress !== void 0 && dropoffAddress.countyCode ? dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.countyCode : dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.country;
      var firstSlot = this.timeModel.availableSlots[0];
      var pickupTime = moment(firstSlot === null || firstSlot === void 0 ? void 0 : firstSlot.startTimeInMs);
      var analyticsPayload = {
        timeEstimate: (_this$deliveryModel32 = this.deliveryModel) === null || _this$deliveryModel32 === void 0 ? void 0 : _this$deliveryModel32.timeEstimate,
        address: {
          addressLine1: dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.addressLine1,
          addressLine2: (_this$deliveryModel33 = this.deliveryModel) === null || _this$deliveryModel33 === void 0 ? void 0 : _this$deliveryModel33.suiteOrApartmentNumber,
          state: dropOffAddressState,
          city: dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.city,
          zipcode: dropoffAddress === null || dropoffAddress === void 0 ? void 0 : dropoffAddress.zipCode,
          country: dropOffAddressCountry
        },
        deliveryDate: pickupTime.format("MM/DD/YYYY"),
        quoteId: (_this$deliveryModel34 = this.deliveryModel) === null || _this$deliveryModel34 === void 0 ? void 0 : (_this$deliveryModel35 = _this$deliveryModel34.togoDeliveryQuote) === null || _this$deliveryModel35 === void 0 ? void 0 : _this$deliveryModel35.quoteId
      };
      (_this$rootStore$user4 = this.rootStore.user) === null || _this$rootStore$user4 === void 0 ? void 0 : _this$rootStore$user4.analyticsModel.dispatchTogoDeliveryQuoteSubmittedEvent(analyticsPayload);
    }
  }, {
    key: "isDeliveryLoading",
    get: function get() {
      return this._isDeliveryLoading;
    },
    set: function set(_isDeliveryLoading) {
      var _this4 = this;

      runInAction(function () {
        _this4._isDeliveryLoading = _isDeliveryLoading;
      });
    }
  }, {
    key: "isDeliveryPageLoading",
    get: function get() {
      return this._isDeliveryPageLoading;
    },
    set: function set(_isDeliveryPageLoading) {
      var _this5 = this;

      runInAction(function () {
        _this5._isDeliveryPageLoading = _isDeliveryPageLoading;
      });
    }
  }, {
    key: "isDeliverySwitchLoading",
    get: function get() {
      return this._isDeliverySwitchLoading;
    },
    set: function set(_isDeliverySwitchLoading) {
      var _this6 = this;

      runInAction(function () {
        _this6._isDeliverySwitchLoading = _isDeliverySwitchLoading;
      });
    }
  }, {
    key: "showHeaderHamburgerMenu",
    set: function set(val) {
      var _this7 = this;

      runInAction(function () {
        _this7._showHeaderHamburgerMenu = val;
      });
    },
    get: function get() {
      return this._showHeaderHamburgerMenu;
    }
  }, {
    key: "isTogo",
    set: function set(val) {
      var _this8 = this;

      runInAction(function () {
        _this8._isTogo = val;
      });
    },
    get: function get() {
      return this._isTogo;
    }
  }]);

  return Delivery;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_isDeliveryLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_isDeliveryPageLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_isDeliverySwitchLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_showHeaderHamburgerMenu", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_storeName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_isTogo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isDeliveryLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeliveryLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDeliveryPageLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeliveryPageLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDeliverySwitchLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeliverySwitchLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isTogo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTogo"), _class.prototype)), _class);
export { Delivery as default };